import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=35023b2e&scoped=true&"
import script from "./RoleCard.vue?vue&type=script&lang=js&"
export * from "./RoleCard.vue?vue&type=script&lang=js&"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=35023b2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35023b2e",
  null
  
)

export default component.exports